import gql from 'graphql-tag'
export default gql`
  mutation updateOrganisation($token: String!, $id: Int!, $name: String!) {
    updateOrganisation(token: $token, id: $id, name: $name)
  }
`
